export default __webpack_public_path__ + "static/media/google-icon.538540a7.svg";